import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function adminHeaders() {
  const pwd = localStorage.getItem("rcv_admin_pwd") || "";
  return { "X-Admin-Password": pwd };
}
